import script from "./EditQInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./EditQInfo.vue?vue&type=script&setup=true&lang=js"

import "./EditQInfo.vue?vue&type=style&index=0&id=af8e4dfa&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af8e4dfa"]])

export default __exports__